import styled from 'styled-components';

export const DocumentsCardsStyles = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
	gap: 0.5rem;

	> .document {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		width: 100%;
		overflow: hidden;
		padding: 0.75rem 1rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		background: ${({ theme }) => theme.v3.colors.white[0]};
		text-align: left;
		cursor: pointer;

		&:hover {
			border-color: ${({ theme }) => theme.v3.colors.blue[6]};
		}

		> .details {
			display: flex;
			flex-direction: column;
			min-width: 0;
		}
	}
`;
